import React, { useEffect } from 'react'
import useGetEPLine from './hook/useGetEPLine';
import { Card, Spin, Table } from 'antd';
import { epLineColumns } from './hook/useColumn';

const EPLineDashboard = () => {
    const params = new URLSearchParams(window.location.search);
    const docNo = params.get('docNo');
    const { onGetEPLine, loading, dataSource } = useGetEPLine();

    useEffect(() => {
        if (docNo) {
            onGetEPLine(docNo);
        }
    }, [docNo]);
    return (
        <Spin spinning={loading}>
            <div style={{ padding: '40px' }}>
                <Card title="รายการอนุมัติ">
                    <Table
                        dataSource={dataSource}
                        columns={epLineColumns}
                    />
                </Card>
            </div>
        </Spin>
    )
}

export default EPLineDashboard